module.exports = __webpack_public_path__ + "static/tc-f85cadeceaef2795c0d5a5ce060feccd.svg";